import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArrayPipe',
  standalone: true,
})
export class FilterArrayPipe implements PipeTransform {
  transform(value: Array<any>, key: string, matchingKey: string): Array<any> {
    if (value?.length > 0 && key && matchingKey) {
      return value?.filter((item) => {
        return item[key] === matchingKey;
      });
    }
    return value;
  }
}
